import React from 'react'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import EmailIcon from '@mui/icons-material/Email'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import LinkedInIcon from '@mui/icons-material/LinkedIn'

function Footer() {
  return (
    <footer className="footer">
      <div className="websiteFooter">
        <div className="aboutCompany2">
          <div className="aboutCompany">
            <h4>Homescare Real Estate Broker L.L.C.</h4>
            <p>
              The company works in real estate and conducts management,
              operation, development, marketing and maintenance services for all
              types of real estate, residential, commercial, administrative, as
              well as real estate consultancy for all types of properties to
              maximize value and increase revenue as it is undertaking a number
              of other services (Cleaning services - Buffets - Expansion in the
              application of security systems for all properties).
            </p>
          </div>
          <div className="followUs">
            <h4>FOLLOW US</h4>
            <div className="followUsIcons">
              <div className="facebk">
                <a
                  className="followUsIcon icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/homescare.mohammed.7?mibextid=ZbWKwL"
                >
                  <FacebookIcon fontSize="small" />
                </a>
              </div>
              <div className="twit">
                <a
                  className="followUsIcon icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/hcre3554456?t=0g-cX6D4EYshbkRSOznW9Q&s=08"
                >
                  <TwitterIcon fontSize="small" />
                </a>
              </div>
              <div className="insta">
                <a
                  className="followUsIcon icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/homescare_re/"
                >
                  <InstagramIcon fontSize="small" />
                </a>
              </div>
              <div className="linkedIn">
                <a
                  className="followUsIcon icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/homecare-re-1541a0261/"
                >
                  <LinkedInIcon fontSize="small" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="contactUs">
          <h4>CONTACT US</h4>
          <div className="contactUsDetail">
            <p className="iconwithtext">
              <div className="icon">
                <EmailIcon fontSize="small" />
              </div>
              <div>admin@homescarere.com</div>
            </p>
            <p className="iconwithtext">
              <div className="icon">
                <PhoneAndroidIcon fontSize="small" />
              </div>
              <div>+971 50 678 5771</div>
            </p>
            <p className="iconwithtext">
              <div className="icon">
                <LocalPhoneIcon fontSize="small" />
              </div>
              <div>+971 4 355 4456</div>
            </p>
            <p className="iconwithtext">
              <div className="icon">
                <LocationOnIcon fontSize="small" />
              </div>
              <div>Office 7, Naser Khamis Building, Bur Dubai, Dubai</div>
            </p>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div>
          &#169; Copyright <span> Homescare Real Estate Broker L.L.C.</span> All
          Rights Reserved.
        </div>
      </div>
    </footer>
  )
}

export default Footer
